const STRINGS = {
  firstButtonLabel: "OK",
  secondButtonLabel: "Cancel",
  closeButtonAriaLabel: title => `Close ${title ? title : ""} message`
};
export default STRINGS;